import React from 'react';
import StateMessage from '../StateMessage/StateMessage';

const FilterNoData = ({ label }) => (
  <StateMessage illustration={'lineal_liquidaciones_empty'} title={label} />
);

export default FilterNoData;
